<template>
  <!-- Buy Digits Section Begins -->
  <div class="buy-digits-section">
    <!-- Heading Section Begins -->
    <div class="has-text-weight-bold margin-bottom-15" v-if="configurations.header">
      <slot name="header">You have no reply credits remaining</slot>
    </div> <!-- Heading Section Ends -->
    <img src="/static/img/competitors/lock.svg" class="margin-right-15"/>
    <a :href="subscUpgradeUrl" class="blue-link" data-track="Upgrade link">Upgrade</a>
    {{configurations.upgradeText}}
    <!-- Credit Addon Info Begins -->
    <div class="input-row is-clearfix" v-if="configurations.buy && canPurchaseReviewsAndInvites">
      <input
        min="1"
        type="number"
        class="input is-inline-block has-text-centered"
        placeholder="Amount"
        autocomplete="off"
        v-model="credits"
      />
      <span class="is-inline-block has-text-centered label-box">
        {{configurations.name}}
      </span>
      <span class="net-amount">R{{price}} excl. vat</span>
      <a
        href="#"
        data-track="Purchase link"
        class="margin-left-14"
        :class="[credits ? 'blue-link' : 'link-disabled']"
        @click.prevent="purchaseDigits(addOns)"
      >
        Purchase now
      </a>
    </div> <!-- Credit Addon Info Ends -->
  </div> <!-- Buy Digits Section Ends -->
</template>

<script>
  import {misc} from '@/mixins'

  export default {
    name: 'BuyDigits',
    mixins: [misc],
    props: {
      config: {
        type: Object,
        required: false
      }
    },
    data () {
      return {
        credits: 100,
        addOns: {
          addOnCredits: 0,
          addOnInvites: 0
        },
        defaultConfig: {
          buy: true,
          name: '',
          type: '',
          header: true,
          upgradeText: ``
        }
      }
    },
    computed: {
      /**
       * Component config to control behaviour
       * @return {Object}
       */
      configurations () {
        return {...this.defaultConfig, ...this.config}
      },
      /**
       * Calculate total price as per quantity
       * @return {Number}
       */
      price () {
        let priceType = ''
        switch (this.configurations.type) {
          case 'Invites':
            priceType = 'inviteCreditPrice'
            break
          case 'Credits':
            priceType = 'reviewCreditPrice'
            break
        }
        let total = this.credits * parseInt(this.userInfo.subscription[priceType].toString())
        this.addOns[`addOn${this.configurations.type}`] = this.credits
        return this.formatPrice(total)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .buy-digits-section {
    .input-row {
      margin: 14px 30px 0px;
    }
    input {
      width: 68px !important;
      height: 35px;
      font-size: 12px;
      color: rgba(88, 89, 91, 0.4);
      border: 1px solid rgba(88, 89, 91, 0.32);
    }
    .label-box {
      padding: 8px 17px 7px 24px;
      border: 1px solid rgba(88, 89, 91, 0.32);
      border-left: none;
      margin-right: 15px;
    }

    /* Media Queries */
    /* Tablet View */
    @media screen and (max-width: 991px) {
      .buy-credits {
        font-size: 11px;
      }
      .buy-credits img {
        vertical-align: bottom;
        margin-right: 7px !important;
      }
      .input-row {
        font-size: 12px;
        margin-left: 0;
      }
    }
    /* Mobile View */
    @media screen and (max-width: 767px) {
      .buy-credits {
        text-align: center;
        font-size: 11px;
      }
      .input-row {
        margin-right: 0;
      }
      input {
        width: 126px !important;
        margin-bottom: 20px;
      }
      .label-box {
        margin-right: 0;
        padding: 8px 18px 7px 25px;
      }
      .net-amount {
        float: left;
      }
      .input-row .blue-link {
        float: right;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/BuyDigits.vue